<template>
  <div v-on-clickaway="onClickOutside" class="inline-block relative text-left">
    <div
      :class="{
        'cursor-default pointer-events-none': disabled
      }"
    >
      <span class="rounded-md shadow-sm">
        <button id="sorting-options-menu"
                type="button"
                class="inline-flex items-center justify-between w-full bg-white font-light py-2 px-3 border rounded border-outline-grey"
                aria-haspopup="true"
                aria-expanded="true"
                @click="onDropdownToggle"
        >
          <div
            :class="{
              'opacity-50': disabled
            }"
          >
            <span>{{ activeItem.name || activeItem.id }}</span>
          </div>
          <span
            class="icon-chevron-down text-4xs ltr:ml-4 rtl:mr-4"
            :class="{
              'opacity-50': disabled
            }"
          />
        </button>
      </span>
    </div>

    <transition enter-active-class="transition-all duration-300 ease-out"
                leave-active-class="transition-all duration-300 ease-out"
                enter-class="opacity-0 invisible"
                enter-to-class="opacity-100 visible"
                leave-class="opacity-100 visible"
                leave-to-class="opacity-0 invisible"
    >
      <div v-if="isShowDropdown" class="origin-top-right absolute left-0 w-full bg-white shadow-dropdown mt-1 z-10">
        <div class="max-h-260 overflow-y-auto text-2xs p-1"
             role="menu"
             aria-orientation="vertical"
             aria-labelledby="sorting-options-menu"
        >
          <button v-for="(item, index) in items"
                  :key="item.id"
                  class="disabled:opacity-30 disabled:cursor-default flex items-center justify-between w-full text-left border rounded border-outline-grey py-1 px-2 mb-1 transition-colors duration-300 hover:bg-blue-grey font-light"
                  :class="{ 'bg-blue-grey': item.id === activeItem.id, 'last:mb-0': index === item.length - 1 }"
                  role="menuitem"
                  @click="onChange(item)"
          >
            <span>{{ item.name || item.id }}</span>
            <span v-if="item.active" class="icon-check ltr:ml-2 rtl:mr-2" />
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowDropdown: false
    }
  },
  computed: {
    activeItem() {
      return this.items.find((item) => item.id === this.value)
    }
  },
  methods: {
    onDropdownToggle() {
      this.isShowDropdown = !this.isShowDropdown
    },
    onChange(item) {
      this.$emit('input', item?.id)
      this.$emit('onClick', item?.id)
      this.isShowDropdown = false
    },
    onClickOutside() {
      this.isShowDropdown = false
    }
  }
}
</script>
